/** Public marketing origin used in robots.txt and sitemap.xml. */
export const PUBLIC_SITE_ORIGIN = "https://ecoeng.net";

/**
 * Public HTML routes that exist in the SPA. Do not add login, register,
 * dashboard, admin, API, or PDF file URLs.
 */
export const PUBLIC_SITEMAP_PATHS = [
  "/",
  "/consulting",
  "/pricing",
  "/resources",
  "/resources/plant-species-id",
  "/reports",
  "/contact",
  "/equipment",
  "/services",
  "/au/services",
  "/sg/services",
  "/insights",
  "/track-record",
  "/privacy",
  "/terms",
  "/professional-responsibility",
] as const;

const AI_CRAWLERS = [
  "Googlebot",
  "Google-Extended",
  "Bingbot",
  "GPTBot",
  "ChatGPT-User",
  "ClaudeBot",
  "anthropic-ai",
  "PerplexityBot",
  "Applebot",
  "Applebot-Extended",
  "CCBot",
] as const;

export const ROBOTS_TXT = `User-agent: *
Allow: /

${AI_CRAWLERS.map((ua) => `User-agent: ${ua}\nAllow: /`).join("\n\n")}

Sitemap: ${PUBLIC_SITE_ORIGIN}/sitemap.xml
`;

export function sitemapLoc(path: string): string {
  return path === "/" ? `${PUBLIC_SITE_ORIGIN}/` : `${PUBLIC_SITE_ORIGIN}${path}`;
}

export function buildSitemapXml(paths: readonly string[] = PUBLIC_SITEMAP_PATHS): string {
  const urls = paths
    .map((p) => `  <url>\n    <loc>${sitemapLoc(p)}</loc>\n  </url>`)
    .join("\n");
  return `<?xml version="1.0" encoding="UTF-8"?>
<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">
${urls}
</urlset>
`;
}

export const SITEMAP_XML = buildSitemapXml();
